<div class="container-sm-fluid pt-3 px-sm-4">
    <dx-tabs
        [items]="tabs"
        [selectedItem]="selectedTab"
        [showNavButtons]="false"
        stylingMode="primary"
        (onItemClick)="onTabClick($event)"
    ></dx-tabs>
</div>

@if (selectedTab?.id === 0) {
    <app-next-view-score ></app-next-view-score>
} @else if (selectedTab?.id === 1) {
    <div class="position-relative overflow-hidden h-100 d-flex">
        <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
            <dx-data-grid
                [style]="(`height: calc(100vh - ${offset}px)`)"
                id="nextViewGrid"
                class="grid theme-dependent"
                noDataText=""
                [dataSource]="dataSource"
                [syncLookupFilterValues]="false"
                [allowColumnResizing]="true"
                [focusedRowEnabled]="true"
                [autoNavigateToFocusedRow]="false"
                [showBorders]="true"
                [remoteOperations]="true"
                [columnAutoWidth]="true"
                [wordWrapEnabled]="true"
                [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'next-view-grid-state', savingTimeout: 0 }"
                (onExporting)="onExporting($event)"
                [customizeColumns]="customizeColumns"
                keyExpr="id"
                width="100%"
            >
                <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
                <dxo-paging [pageSize]="10"></dxo-paging>
                <dxo-pager [visible]="true" [displayMode]="'full'" [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                <dxo-load-panel [showPane]="false"></dxo-load-panel>
                <dxo-sorting mode="multiple"></dxo-sorting>
                <dxo-header-filter [visible]="true"></dxo-header-filter>
                <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                    <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                    <dxo-search [enabled]="true"></dxo-search>
                    <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
                </dxo-column-chooser>
                <dxo-search-panel [visible]="true" placeholder="Search"></dxo-search-panel>
                <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>

                <dxo-toolbar>
                    <dxi-item location="before">
                        <div class="grid-header">Efficiency</div>
                    </dxi-item>
                    <dxi-item location="after" locateInMenu="auto" widget="dxButton"
                        [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"></dxi-item>
                    <dxi-item location="after" locateInMenu="auto">
                        <div class="separator"></div>
                    </dxi-item>
                    <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                        [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"></dxi-item>
                    <dxi-item location="after" locateInMenu="auto" showText="inMenu" widget="dxButton"
                        [options]="{ text: 'Reset', icon: 'restore', onClick: resetGrid, stylingMode: 'text' }"></dxi-item>
                    <dxi-item location="after" locateInMenu="auto">
                        <div class="separator"></div>
                    </dxi-item>
                    <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                    <dxi-item name="exportButton"></dxi-item>
                </dxo-toolbar>

                <dxi-column [dataField]="gridFieldName('date')" caption="Date" [minWidth]="50" [sortOrder]="'desc'"></dxi-column>
                <dxi-column [dataField]="'employee.name'" caption="Employee" cellTemplate="employee" [minWidth]="250" [calculateFilterExpression]="employeeFilter" [calculateCellValue]="employeeCellValue"></dxi-column>
                <dxi-column [dataField]="gridFieldName('positionId')" caption="ID" [minWidth]="100" cellTemplate="id"></dxi-column>
                <dxi-column [dataField]="gridFieldName('status')" caption="Status" [minWidth]="50" cellTemplate="status"
                            [lookup]="{ dataSource: employeeStatusOptions, valueExpr: 'value', displayExpr: 'text' }" [headerFilter]="{ dataSource: employeeStatusOptions }"></dxi-column>
                <dxi-column [dataField]="gridFieldName('shift')" caption="Shift" [minWidth]="50"></dxi-column>
                <dxi-column [dataField]="gridFieldName('type')" caption="Type" [minWidth]="50" [lookup]="{ dataSource: productivityReportTypeOptions, valueExpr: 'value', displayExpr: 'text' }" [headerFilter]="{ dataSource: productivityReportTypeOptions }"></dxi-column>
                <dxi-column [dataField]="gridFieldName('stdTotal')" caption="Std Total" [minWidth]="50" [format]="numberFormat" selectedFilterOperation=">="></dxi-column>
                <dxi-column [dataField]="gridFieldName('stdHours')" caption="Std Hours" [minWidth]="50" [format]="numberFormat" selectedFilterOperation=">="></dxi-column>
                <dxi-column [dataField]="gridFieldName('efficiency')" caption="Efficiency" [minWidth]="50" [format]="numberFormat" selectedFilterOperation=">="></dxi-column>
                <dxi-column [dataField]="'lastModifiedBy.name'" caption="Last Modified By" cellTemplate="lastModifiedBy" [minWidth]="150" [visible]="false"></dxi-column>
                <dxi-column [dataField]="gridFieldName('lastModified')" caption="Last Modified" [minWidth]="100" cellTemplate="lastModified" [visible]="false"></dxi-column>
                <dxi-column [dataField]="'createdBy.name'" caption="Created By" cellTemplate="createdBy" [minWidth]="150" [visible]="false"></dxi-column>
                <dxi-column [dataField]="gridFieldName('created')" caption="Created" [minWidth]="100" cellTemplate="created" [visible]="false"></dxi-column>

                <dxi-column type="buttons" caption="Actions" [visible]="canDelete" [showInColumnChooser]="canDelete">
                    <dxi-button text="delete" icon="trash" hint="delete" [onClick]="onDelete"></dxi-button>
                </dxi-column>

                <div *dxTemplate="let cellInfo of 'employee'">
                    @if (getCellData(cellInfo).employeeName) {
                        {{ getCellData(cellInfo).employeeName }}
                    } @else {
                        <user-avatar-email [email]="getCellData(cellInfo).employee.email"
                                        [name]="getCellData(cellInfo).employee.name" 
                                        [avatarUrl]="getCellData(cellInfo).employee.avatarUrl"
                                        [employeeId]="getCellData(cellInfo).employee.id">
                        </user-avatar-email>
                    }
                </div>
                <div *dxTemplate="let cellInfo of 'lastModifiedBy'">
                    @if(getCellData(cellInfo).lastModifiedBy !== undefined)
                    {
                        <user-avatar-email [email]="getCellData(cellInfo).lastModifiedBy.email"
                                        [name]="getCellData(cellInfo).lastModifiedBy.name" 
                                        [avatarUrl]="getCellData(cellInfo).lastModifiedBy.avatarUrl"
                                        [employeeId]="getCellData(cellInfo).lastModifiedBy.id">
                        </user-avatar-email>
                    }
                </div>
                <div *dxTemplate="let cellInfo of 'createdBy'">
                    @if(getCellData(cellInfo).createdBy !== undefined)
                    {
                        <user-avatar-email [email]="getCellData(cellInfo).createdBy.email"
                                        [name]="getCellData(cellInfo).createdBy.name" 
                                        [avatarUrl]="getCellData(cellInfo).createdBy.avatarUrl"
                                        [employeeId]="getCellData(cellInfo).createdBy.id">
                        </user-avatar-email>
                    }
                </div>
                <div *dxTemplate="let cellInfo of 'id'">
                    <div class="text-primary fw-semibold">
                        {{ getCellData(cellInfo).positionId }}
                    </div>
                </div>
                <div *dxTemplate="let cellInfo of 'status'">
                    <span class="badge" [ngClass]="getBadgeClass(getCellData(cellInfo).status)">
                        {{ getCellData(cellInfo).status }}
                    </span>
                </div>
                <div *dxTemplate="let cellInfo of 'lastModified'">
                    {{ getCellData(cellInfo).lastModified | date: dateTimeFormat }}
                </div>
                <div *dxTemplate="let cellInfo of 'created'">
                    {{ getCellData(cellInfo).created | date: dateTimeFormat }}
                </div>
            </dx-data-grid>
        </div>

        <filter-panel [(isOpened)]="isFilterPanelOpened" (onSearch)="applyFilters()" (onClear)="clearFilters()"
            (pinnedChange)="onPinnedChange()">
            <dx-form [formData]="filterModel">
                <dxi-item [dataField]="filterModelName('date')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Date', stylingMode: 'filled', displayFormat: 'dateFormat' }" ></dxi-item>
                <dxi-item [dataField]="'employee.name'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }"></dxi-item>
                <dxi-item [dataField]="filterModelName('positionId')" editorType="dxTextBox" [editorOptions]="{placeholder: 'ID', stylingMode: 'filled'}" [label]="{ text: 'ID' }"></dxi-item>
                <dxi-item [dataField]="filterModelName('status')" editorType="dxSelectBox" [editorOptions]="{ placeholder: 'Status', stylingMode: 'filled', items: employeeStatusOptions, valueExpr: 'value', displayExpr: 'text' }" [label]="{ text: 'Status' }"></dxi-item>
                <dxi-item [dataField]="filterModelName('shift')" editorType="dxTextBox" [editorOptions]="{placeholder: 'Shift', stylingMode: 'filled'}"></dxi-item>
                <dxi-item [dataField]="filterModelName('type')" editorType="dxSelectBox" [editorOptions]="{ placeholder: 'Type', stylingMode: 'filled', items: productivityReportTypeOptions, valueExpr: 'value', displayExpr: 'text' }"></dxi-item>
                <dxi-item [dataField]="filterModelName('stdTotal')" editorType="dxNumberBox" [editorOptions]="{placeholder: 'STD Total', stylingMode: 'filled'}" [label]="{ text: 'STD Total' }"></dxi-item>
                <dxi-item [dataField]="filterModelName('stdHours')" editorType="dxNumberBox" [editorOptions]="{placeholder: 'STD Hours', stylingMode: 'filled'}" [label]="{ text: 'STD Hours' }"></dxi-item>
                <dxi-item [dataField]="filterModelName('efficiency')" editorType="dxNumberBox" [editorOptions]="{placeholder: 'Efficiency', stylingMode: 'filled'}" [label]="{ text: 'Efficiency' }"></dxi-item>
                <dxi-item [dataField]="'lastModifiedBy.name'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }"  [label]="{ text: 'Last Modified By' }"></dxi-item>
                <dxi-item [dataField]="filterModelName('lastModified')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Last Modified Date', stylingMode: 'filled', displayFormat: 'shortDate' }" [label]="{ text: 'Last Modified Date' }"></dxi-item>
                <dxi-item [dataField]="'createdBy.name'" editorType="dxTextBox" [editorOptions]="{ placeholder: 'Employee', stylingMode: 'filled' }" [label]="{ text: 'Created By' }"></dxi-item>
                <dxi-item [dataField]="filterModelName('created')" editorType="dxDateBox" [editorOptions]="{ placeholder: 'Created Date', stylingMode: 'filled', displayFormat: 'shortDate' }" [label]="{ text: 'Created' }"></dxi-item>
            </dx-form>
        </filter-panel>
    </div>
}